import { useEffect, useState } from "react";

import formatDuration from "@/utils/formaty";

import { Typography } from "@mui/material";
import { differenceInSeconds, isAfter } from "date-fns";

export default function TotpTimer({ expires }) {
  const [now, setNow] = useState(Date.now);

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(Date.now());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return <Typography variant="body2">{getTotpTimerLabel(expires, now)}</Typography>;
}

function getTotpTimerLabel(expires, now) {
  const currentDateTime = new Date(now);
  const endDateTime = new Date(expires);

  const seconds = differenceInSeconds(endDateTime, currentDateTime);

  if (isNaN(seconds)) {
    return "2:00";
  }

  if (isAfter(currentDateTime, endDateTime)) {
    return "Session expired";
  }

  return formatDuration(seconds);
}
